import { siteApiSlice } from "../../../../app/siteApiSlice";
import { WriterModel } from "../../shared/Models";

export interface GenreScoreViewModel {
	argumentativeScore: number;
	informativeScore: number;
	narrativeScore: number;
	averageScore: number;
}

export interface EssayGenreScoreViewModel extends GenreScoreViewModel {
	essayId: number;
	genreId: number;
	date: Date;
	promptName: string;
}

export interface EssayBaseViewModel {
	essayId: number;
	date: Date;
	promptName: string;
	draftCount: number;
}
export interface EssayTraitScoreViewModel {
	developmentOfIdeasScore?: number;
	organizationScore?: number;
	styleScore?: number;
	wordChoiceScore?: number;
	sentenceStructureScore?: number;
	conventionsScore?: number;
	totalScore?: number;
	textualEvidenceScore?: number;
	contentAccuracyScore?: number;
}

export interface CrTraitScoreViewModel {
	totalScore?: number;
	textualEvidenceScore?: number;
	contentAccuracyScore?: number;
}

export interface EssayScoreRankModel {
	percentileRank?: number;
	stanine?: number;
}

export interface EssayTraitScoreWithNormsViewModel
	extends EssayBaseViewModel,
		EssayTraitScoreViewModel,
		EssayScoreRankModel {}

export interface CrTraitScoreWithNormsViewModel
	extends EssayBaseViewModel,
		CrTraitScoreViewModel,
		EssayScoreRankModel {}

export interface ScoresFilteredByWriterViewModel extends WriterModel {
	courseId: number;
	proctorMode: boolean;
	normativeReportsEnabled: boolean;
	averageTraitScoresByEssay: EssayTraitScoreWithNormsViewModel[];
	averageConstructedResponseScoresByEssay: CrTraitScoreWithNormsViewModel[];
	averageTraitScoresForWriter: EssayTraitScoreViewModel;
	averageConstructedResponseScoresForWriter: CrTraitScoreViewModel;
	averageStandardScoresByEssay: EssayGenreScoreViewModel[];
	averageStandardScoresForWriter: GenreScoreViewModel;
}

export const performanceReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		performanceReport: build.query<
			ScoresFilteredByWriterViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/performance-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["WritingHistory", "CurrentCourse"],
		}),
	}),
});

export const { usePerformanceReportQuery } = performanceReportApiSlice;
